import axios from 'axios';

const anotherInstance = axios.create({
  baseURL: 'https://superbot.sektaschool.ru/api/',
  timeout: 1000,
  headers: { 'X-Custom-Header': 'another-foobar' }
}); 

export { anotherInstance };